<div class="spinner-container" *ngIf="loading">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-card-content class="container details" *ngIf="!loading">
    <div class="row">
        <div class="col-md-12">
            <div class="message" *ngIf="!hasData()">
                {{'certificates.noCertificates' | translate}}
            </div>
            <div class="data-container" *ngIf="hasData()">
                <div class="mat-elevation-z8 table-content">
                    <mat-table [dataSource]="hardwareCertificates" matSort matSortActive="requestNumber"
                        matSortDirection="desc" (matSortChange)="onSortEvent($event)" multiTemplateDataRows>
                        <ng-container matColumnDef="type">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{ 'certificates.type' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell type-cell" matTooltip="{{ row.type }}">
                                    {{ row.type }}
                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="serialNumber">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{'certificates.serialNumberTable' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell" matTooltip="{{ row.serialNumber }}">
                                    {{ row.serialNumber }}
                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="clientName">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{'certificates.nameOfClientTable' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell">
                                    {{row.clientName}}
                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="clientIdentification">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{'certificates.idOfClientTable' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell">
                                    {{ row.clientIdentification | maskEgn }}
                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="validFrom">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{'certificates.validFrom' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell">
                                    {{row.validFrom}}
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="validTo">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{'certificates.validTo' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell">
                                    {{row.validTo}}
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>
                                {{'certificates.status' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell">
                                    {{mapCertificateStatus(row.status)}}
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <mat-header-cell class="header-align-right" *matHeaderCellDef>
                                {{ 'certificates.actions' | translate }}
                            </mat-header-cell>

                            <mat-cell *matCellDef="let row">
                                <ng-container>
                                    <span [matMenuTriggerFor]="docs" class="action">
                                        <button mat-icon-button color="primary">
                                            <cqes-icon icon="menu"></cqes-icon>
                                        </button>
                                    </span>
                                    <mat-menu #docs="matMenu">
                                        <div *ngIf="row.status === 'VALID' || row.status === 'HOLDED'">
                                            <div *ngIf="row.type != 'OTC-RP-BASED-ID'">
                                                <button mat-menu-item (click)="routeToManagment(row)"
                                                    *ngIf="row?.type !== 'CQES' && !isCertTypePersonal(row)"
                                                    matTooltip="{{'certificates.actionButtons.manage'| translate}}">
                                                    <cqes-icon icon="settings"></cqes-icon>
                                                    {{'certificates.actionButtons.manage' | translate}}
                                                </button>
                                            </div>
                                        </div>
                                        <button mat-menu-item (click)="routeToHistory(row)"
                                            matTooltip="{{'certificates.actionButtons.certificateHistory'| translate}}">
                                            <cqes-icon icon="text_snippet"></cqes-icon>
                                            {{'certificates.actionButtons.certificateHistory' | translate}}
                                        </button>
                                    </mat-menu>
                                </ng-container>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;" class="expand-element-row">
                        </mat-row>
                    </mat-table>

                    <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="pageIndex"
                        [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons (page)="onPageEvent($event)">
                    </mat-paginator>
                </div>

            </div>
        </div>
    </div>

</mat-card-content>